import Helper, { createHost, createMockContext, attach, attachAll, registry, createRegistry, createContextRegistry } from './helper'

export {
  attach,
  attachAll,
  registry,
  createRegistry,
  createContextRegistry,
  createHost,
  createMockContext
}

export default Helper

Helper.registry.register('feature', () => require('./helpers/feature'))


// WEBPACK FOOTER //
// ./src/index.js